import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { formatINR } from "@/lib/format";

export const AuditLogTable = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["audit-log"],
    queryFn: async () => (await api.get("/audit-log")).data,
  });

  return (
    <div
      className="bg-white border border-[#DCE3DF] rounded-[10px] shadow-[0_4px_20px_rgba(20,30,26,0.06)] p-6"
      data-testid="audit-log-table"
    >
      <h3 className="text-lg font-display font-medium text-[#141E1A] mb-4">Audit Log</h3>
      {isLoading ? (
        <p className="text-sm text-[#5A6B63]">Loading…</p>
      ) : !data?.length ? (
        <p className="text-sm text-[#5A6B63]" data-testid="audit-log-empty">
          No bookings yet. Book an invoice to see it here.
        </p>
      ) : (
        <Table>
          <TableHeader>
            <TableRow className="border-[#DCE3DF]">
              <TableHead>Timestamp</TableHead>
              <TableHead>Invoice #</TableHead>
              <TableHead>PO Ref</TableHead>
              <TableHead>Department</TableHead>
              <TableHead>Amount</TableHead>
              <TableHead>Result</TableHead>
              <TableHead>Booked By</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((row) => (
              <TableRow key={row.id} className="border-[#DCE3DF]" data-testid={`audit-log-row-${row.id}`}>
                <TableCell className="font-mono text-xs">{new Date(row.timestamp).toLocaleString("en-IN")}</TableCell>
                <TableCell className="font-mono text-sm">{row.invoice_number || "—"}</TableCell>
                <TableCell className="font-mono text-sm">{row.po_reference || "—"}</TableCell>
                <TableCell className="text-sm">{row.department}</TableCell>
                <TableCell className="font-mono text-sm">{formatINR(row.grand_total)}</TableCell>
                <TableCell>
                  <Badge
                    className={
                      row.result === "booked"
                        ? "bg-[#E4F1EB] text-[#0E6E52] border-[#0E6E52]/20"
                        : "bg-[#B7791A]/10 text-[#B7791A] border-[#B7791A]/20"
                    }
                  >
                    {row.result}
                  </Badge>
                </TableCell>
                <TableCell className="font-mono text-xs">{row.booked_by}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};
